module.exports = __webpack_public_path__ + "static/media/banner4.0c535c6b.jpg";